import type { Animation } from '@ionic/core';
import { createAnimation, DURATION_SHORT_4, EASING_EMPHASIZED_ACCELERATE } from '../../../../utils/animations';
import { accordionItemOpenAnimation } from './open';

export function accordionItemCloseAnimation(accordionItem: HTMLElement): Animation {
  return accordionItemOpenAnimation(accordionItem)
    .direction('reverse')
    .easing(EASING_EMPHASIZED_ACCELERATE)
    .duration(DURATION_SHORT_4);
}

export function accordionBorderCloseAnimation(accordionItem: HTMLElement, defaultValue: string): Animation {
  return createAnimation()
    .duration(DURATION_SHORT_4)
    .fromTo('borderBottomLeftRadius', '0', defaultValue)
    .fromTo('borderBottomRightRadius', '0', defaultValue)
    .addElement(accordionItem)
    .easing('ease-in');
}

export function accordionIconCloseAnimation(accordionIcon: HTMLElement): Animation {
  return createAnimation()
    .duration(DURATION_SHORT_4)
    .fromTo('rotate', '', '-90deg')
    .addElement(accordionIcon)
    .easing('ease-in');
}
